// eslint-disable-next-line import/no-default-export
export default class RichError extends Error {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  metadata: Record<string, any>;

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(message: string, metadata: Record<string, any>) {
    super(message);
    this.name = 'RichError';
    this.metadata = metadata;
  }
}
